/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-intake
 * crm-screener-intake
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BidirectionalActionConfigDate
 */
export interface BidirectionalActionConfigDate {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    required: boolean;
    /**
     * 
     */
    disable_past?: boolean;
    /**
     * A QuestionFieldCondition or an array of QuestionFieldCondition. The field is shown only when all conditions match. Kept untyped because the frontend generator emits invalid code for this union.
     */
    show_if?: any | null;
}

/**
 * Check if a given object implements the BidirectionalActionConfigDate interface.
 */
export function instanceOfBidirectionalActionConfigDate(value: object): value is BidirectionalActionConfigDate {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('required' in value) || value['required'] === undefined) return false;
    return true;
}

export function BidirectionalActionConfigDateFromJSON(json: any): BidirectionalActionConfigDate {
    return BidirectionalActionConfigDateFromJSONTyped(json, false);
}

export function BidirectionalActionConfigDateFromJSONTyped(json: any, ignoreDiscriminator: boolean): BidirectionalActionConfigDate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'required': json['required'],
        'disable_past': json['disable_past'] == null ? undefined : json['disable_past'],
        'show_if': json['show_if'] === undefined ? undefined : json['show_if'] === null ? null : json['show_if'],
    };
}

export function BidirectionalActionConfigDateToJSON(json: any): BidirectionalActionConfigDate {
    return BidirectionalActionConfigDateToJSONTyped(json, false);
}

export function BidirectionalActionConfigDateToJSONTyped(value?: BidirectionalActionConfigDate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'required': value['required'],
        'disable_past': value['disable_past'],
        'show_if': value['show_if'],
    };
}

